// extracted by mini-css-extract-plugin
module.exports = {"switch":"_7VAuY","slider":"r7wEh","round":"VqYnT"};